var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',{staticClass:"m-3",on:{"click":function($event){return _vm.actionCompleted()}}},[_vm._v("test2")])}
var staticRenderFns = []

export { render, staticRenderFns }